import { motion, AnimatePresence } from "framer-motion";
import DiscreteSlider from "components/widgets/Slider/Slider";
import UnityActionsWindow from "../UnityActionsWindow/UnityActionsWindow";
import { useUnityActions } from "hooks/unityActions";
import { memo, useContext } from "react";
import { ModalContext } from "hooks/ModalProvider";

type UnityMenuProps = {
  TimelineShown: boolean;
  isModalOpen: boolean;
};

const UnityMenu = ({ TimelineShown, isModalOpen }: UnityMenuProps) => {
  const { editingMode } = useUnityActions();
  const { modalType } = useContext(ModalContext);

  return (
    <motion.div
      key="discrete-slider-container"
      className="absolute top-10 w-full h-max z-50 left-0 flex items-center justify-center flex-wrap gap-8 pointer-events-none"
      initial={false}
      animate={{ top: TimelineShown ? 88 : 68 }}
      transition={{ duration: 0.4, ease: "easeInOut" }}
    >
      {/* DiscreteSlider Animation */}
      <AnimatePresence>
        {TimelineShown && !editingMode && (
          <motion.div
            key="discrete-slider"
            className="z-30 pointer-events-auto h-[60px]"
            initial={{ opacity: 1, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 1, y: -20 }}
            transition={{ duration: 0.1, ease: "easeOut" }}
          >
            <DiscreteSlider />
          </motion.div>
        )}
      </AnimatePresence>

      {/* UnityActionsWindow - No Animation Needed Here Anymore */}
      {modalType === '' && (
        <div className="w-full flex items-center justify-center pointer-events-auto">
          <UnityActionsWindow />
        </div>
      )}
    </motion.div>
  );
};

// Custom comparison to prevent re-renders unless props change
const areEqual = (prev: UnityMenuProps, next: UnityMenuProps) =>
  prev.TimelineShown === next.TimelineShown && prev.isModalOpen === next.isModalOpen;

export default memo(UnityMenu, areEqual);
